import React from 'react';
import PropTypes from 'prop-types';
import { FlexBox, Box } from '@vp/swan';

import { CustomIframeDisplay } from './CustomIframeDisplay';
import { CustomTextDisplay } from './CustomTextDisplay';
import { CustomPopupTextDisplay } from './CustomPopupTextDisplay';

const CUSTOM_DATA_TYPES = {
  TEXT: 'TEXT',
  POPUP_TEXT: 'POPUP_TEXT',
  URL: 'URL',
};

export const CustomDataDisplay = ({ customDisplayAttributes = [] }) => {
  const getCustomDataComponent = attribute => {
    switch (attribute.type) {
      case CUSTOM_DATA_TYPES.TEXT:
        return <CustomTextDisplay attribute={attribute} />;
      case CUSTOM_DATA_TYPES.POPUP_TEXT:
        return <CustomPopupTextDisplay attribute={attribute} />;
      case CUSTOM_DATA_TYPES.URL:
        return <CustomIframeDisplay attribute={attribute} />;
      default:
        return null;
    }
  };

  return (
    <FlexBox justifyContent="space-between" flexDirection="column">
      {customDisplayAttributes.map(attribute => (
        <Box marginBottom="2">{getCustomDataComponent(attribute)}</Box>
      ))}
    </FlexBox>
  );
};
CustomDataDisplay.propTypes = {
  customDisplayAttributes: PropTypes.array,
};
